import { call, put } from 'redux-saga/effects';
import { BACKEND_URL, FRONT_URL } from '../../../configs';
import { authorizedLoginFailed, authorizedLogoutSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import processError from '../../../utils/processError';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';

export default function* authorizedLogout(action) {
  try {
    if (window.updateTimers && window.updateTimers.length) {
      for (let i = 0, len = window.updateTimers.length; i < len; i++) {
        clearTimeout(window.updateTimers[i]);
      }
    }
    const url = `${BACKEND_URL}/profile/logout`;
    const response = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield getBodyJson(response);
    yield put(authorizedLogoutSuccessful());
    yield call(resolveActionPromise(action, data));
  } catch (e) {
    yield put(authorizedLogoutSuccessful());
    yield processError(e);
  }
}
